export default "__VITE_ASSET__BRQlvlYT__"